import React from "react";

const RollIdPrompt = () => {
  return null;
};

export default RollIdPrompt;
